import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CommonService } from '../../../common.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
declare var $: any;

@Component({
  selector: 'app-add-animal-diagnostic',
  templateUrl: './add-animal-diagnostic.component.html',
  styleUrls: ['./add-animal-diagnostic.component.css']
})
export class AddAnimalDiagnosticComponent implements OnInit {

  Formvalidation: FormGroup;

  addDiagnosticFormValue: any;
  addUrl: any;
  loginresponse: any;
  cby_mby: any;

  Dateoftest: any;
  diagnostictestname: any;

  Dateoftesterror: boolean = false;
  diagnostictestnameerror: boolean = false;

  returnUrl = "/dashboard/RottweilerDogsAnimalmanagement";
  constructor(private router: Router, private commonService: CommonService, private formbuild: FormBuilder) {

    this.Formvalidation = this.formbuild.group({
      Dateoftest: ['', Validators.required],
      diagnostictestname: ['', Validators.required]
    })

  }

  ngOnInit(): void {
    this.loginresponse = JSON.parse(sessionStorage.getItem('userrole'));
    this.cby_mby = this.loginresponse.user_id;
  }

  async AnimalDiagnostic() {

    if (!this.Dateoftest || !this.diagnostictestname) {

      if (!this.diagnostictestname) {
        this.diagnostictestnameerror = true;
      } else {
        this.diagnostictestnameerror = false;
      }

      if (!this.Dateoftest) {
        this.Dateoftesterror = true;
      } else {
        this.Dateoftesterror = false;
      }

      return;

    }


    var farmid = sessionStorage.getItem('farmid');
    var Animalid = sessionStorage.getItem('animalid');
    var speciesid = sessionStorage.getItem('speciesid');
    var breedid = sessionStorage.getItem('breedid');
    var ageid = sessionStorage.getItem('ageid');

    this.addDiagnosticFormValue = {
      "species_id": speciesid,
      "breed_id": breedid,
      "farm_id": farmid,
      "animal_code": Animalid,
      "age_group": ageid,
      "diagnostics_test_name": $("#Diagnostictest").val(),
      "date_of_test": $("#Dateoftest").val(),
      "diagnostics_description": $("#Description").val(),
      "cby": this.cby_mby,
      "status": 1,
      "is_active": 1
    };

    console.log(this.addDiagnosticFormValue)
    this.addUrl = "/animal_management/diagnostics";
    (await this.commonService.postApi(this.addUrl, this.addDiagnosticFormValue)).subscribe(
      data => {
        alert("Data added successfully");
      });
    setTimeout(
      (): void => {

        this.router.navigate([this.returnUrl, { fragment: 'Disease' }]);

      },
      500
    );
    //}
  }

  backnavigate() {
    this.router.navigate([this.returnUrl]);
  }

}
